




































import { defineComponent } from "@vue/composition-api";
import { IconCardGrid } from "@/components.generic/icon-card-grid";
import { useTags } from "@/hooks/useTags";
import { useFavourites } from "@/hooks/useFavourites";
import { Tag } from "@/psychlab/types/tags";
import * as AppModal from "@/AppModal";
import { Icon, RouteButton, AbsBox, ContextOption } from "@ui";
import { useTranslate } from "@lang";

export default defineComponent({
	components:{
		IconCardGrid,
		Icon,
		RouteButton,
		AbsBox,
	},
	setup(_, context){

		const {
			sortedTags,
			editTag,
			createTag,
			deleteTag,
		} = useTags();

		const {
			addFavourite,
			removeFavourite,
			isFavourite
		} = useFavourites();

		const { translate } = useTranslate();

		const getTagRoute = (tag:Tag) => {

			const query:any = { ...context.root.$route.query };
			return {
				name:'view-tag', 
				params:{
					tagId:tag._id
				},
				query
			}
		};
		
		const onAddTag = () => {
			AppModal.editText({
				title:translate("tags.action.newTag"),
				value:"",
				validator: v => v.length > 1,
			},  v => createTag(v));
		};

		const rename = (tag:Tag) => {
			AppModal.editText({
				title:translate("action.rename"),
				value:tag.name,
				validator:v => v !== tag.name,
			}, v => editTag(tag._id, { name:v }));
		};

		const setColor = (tag:Tag) => {
			AppModal.editColor({
				title:translate("tags.action.setTagColor"),
				value:tag.color
			}, v => editTag(tag._id, { color:v }));
		};

		const delTag = (tag:Tag) => {
			AppModal.confirm({
				title:translate("tags.action.deleteTag"),
				variant:"danger",
				okText:translate("prompts.action.understood"),
				description:translate("prompts.message.irreversible")
			}, () => deleteTag(tag._id));
		};

		const openContext = (event:any, tag:Tag) => {

			const options:ContextOption[] = [];

			if(isFavourite(tag._id)){
				options.push({
					name:translate("action.removeFromFavourites"),
					icon:"mdi.star-outline",
					variant:"light",
					order:0,
					fn:() => removeFavourite(tag._id),
				});
			}
			else {
				options.push({
					name:translate("action.addToFavourites"),
					icon:"mdi.star",
					variant:"light",
					order:0,
					fn:() => addFavourite(tag._id, "tag"),
				});
			}

			options.push({
				name:translate("action.rename"),
				icon:"mdi.pencil",
				variant:"light",
				order:1,
				fn:() => rename(tag),
			});

			options.push({
				name:translate("action.setColor"),
				icon:"mdi.format-color-fill",
				variant:"light",
				order:1,
				fn:() => setColor(tag),
			});

			options.push({
				name:translate("action.delete"),
				icon:"mdi.trash-can",
				order:2,
				fn:() => delTag(tag),
			});
			AppModal.context(event, options);
		};

		return {
			tags:sortedTags,
			translate,
			getTagRoute,
			openContext,
			onAddTag,
		};
	}
});

